import { apiClient } from '@/services/ApiClient.js'

export class PaymentReminderService {
  query

  constructor(query) {
    this.query = query
  }

  getPaymentReminders() {
    return apiClient
      .get('payment-reminders', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updatePaymentReminder(id, reminder) {
    return apiClient
      .patch('payment-reminders/' + id, reminder)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  sendPaymentReminderSMS(id) {
    return apiClient
      .post('payment-reminders/' + id + '/send-reminder-sms')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  assign(reminders) {
    return apiClient
      .post('payment-reminders/assign', reminders)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  stats() {
    return apiClient
      .get('payment-reminders/stats')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  phoneSurveyFilterOptions() {
    return apiClient
      .get('payment-reminders/phone-survey-filter-options')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
